import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  createEventsCollection,
  deleteEventsCollection,
  updateEventsCollection,
} from '@store/membership/EventsCollectionReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

const EventsCollectionForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.eventsCollection)

  const rewriteRangeQuery = (rangeQuery?: [number, number]) => {
    if (!rangeQuery) {
      return { periodStart: null, periodEnd: null }
    }
    const [start, end] = rangeQuery
    return {
      periodStart: start,
      periodEnd: end === 80 ? null : end,
    }
  }

  const rewriteValues = (values: any) => ({
    ...values,
    ...rewriteRangeQuery(values.rangeQuery),
    rangeQuery: undefined,
  })

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) =>
          dispatch(createEventsCollection(rewriteValues(values))).then(() => {
            return true
          }),
        update: async (values) =>
          dispatch(updateEventsCollection(rewriteValues(values))).then(() => {
            return true
          }),
        delete: async (values) =>
          dispatch(deleteEventsCollection(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

EventsCollectionForm.displayName = 'EventsCollectionForm'

export default EventsCollectionForm
